export default {
  cstCollection: [],
  cstIPICollection: [],
  cstPISCollection: [],
  cstCOFINSCollection: [],
};
